/* ============================================================
   Mighty slide-out cart — flicker-free quantity updates
   Dawn re-renders the ENTIRE .drawer__inner on a qty change, which destroys
   and recreates the stepper (the flicker). This overrides the drawer's
   updateQuantity to PATCH the changed regions in place and leave the
   quantity-input untouched. Removals still use the original full re-render
   (the row is leaving anyway). Also: spinner on the clicked +/-, optimistic (xN).
   ============================================================ */
(function () {
  'use strict';

  // Immediate feedback on click: spinner on the clicked button + optimistic (xN).
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('.mc-qty .quantity__button');
      if (!btn || !btn.closest('cart-drawer')) return;
      btn.classList.add('is-loading');
      const row = btn.closest('.mc-item');
      const input = row && row.querySelector('.quantity__input');
      const priceEl = row && row.querySelector('.mc-item__price');
      const each = priceEl && priceEl.querySelector('.mc-item__each');
      if (!input || !priceEl || !each) return;
      const cur = parseInt(input.value, 10) || 1;
      const next = btn.name === 'plus' ? cur + 1 : Math.max(1, cur - 1);
      let mult = priceEl.querySelector('.mc-item__mult');
      if (next > 1) {
        if (!mult) {
          mult = document.createElement('span');
          mult.className = 'mc-item__mult';
          each.insertAdjacentElement('afterend', mult);
        }
        mult.textContent = '(x' + next + ')';
      } else if (mult) {
        mult.remove();
      }
    },
    true
  );

  function patchRegion(doc, sel) {
    const src = doc.querySelector(sel);
    const tgt = document.querySelector('#CartDrawer ' + sel);
    if (src && tgt) tgt.innerHTML = src.innerHTML;
  }

  customElements.whenDefined('cart-drawer-items').then(function () {
    const CDI = customElements.get('cart-drawer-items');
    if (!CDI || CDI.__mcQtyPatched) return;
    CDI.__mcQtyPatched = true;
    const origUpdate = CDI.prototype.updateQuantity;

    CDI.prototype.updateQuantity = function (line, quantity, name, variantId) {
      // Removal -> safe original full re-render (no stepper-flicker concern).
      if (Number(quantity) <= 0) {
        return origUpdate.call(this, line, quantity, name, variantId);
      }

      const self = this;
      this.enableLoading(line);
      const body = JSON.stringify({
        line: line,
        quantity: quantity,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      });

      fetch(routes.cart_change_url, Object.assign({}, fetchConfig(), { body: body }))
        .then(function (r) { return r.text(); })
        .then(function (state) {
          const parsed = JSON.parse(state);
          if (parsed.errors) {
            const qi = document.getElementById('Drawer-quantity-' + line);
            if (qi) qi.value = qi.getAttribute('value');
            const errBox = document.getElementById('CartDrawer-CartErrors');
            if (errBox) errBox.textContent = window.cartStrings ? window.cartStrings.error : 'Error';
            return;
          }
          const drawerHTML = parsed.sections && parsed.sections['cart-drawer'];
          if (drawerHTML) {
            const doc = new DOMParser().parseFromString(drawerHTML, 'text/html');
            // Only patch regions that actually change on a qty change. NOT .mc-scroll-extra
            // (it contains the subscribe panel, which is unchanged and would flash).
            ['.mc-head', '.mc-banners', '.mc-summary', '.mc-footer'].forEach(function (sel) {
              patchRegion(doc, sel);
            });
            // Each item's price/tags: patch in place, never touch the quantity-input.
            document.querySelectorAll('#CartDrawer .mc-item').forEach(function (rowEl) {
              const src = doc.getElementById(rowEl.id);
              if (!src) return;
              ['.mc-item__price', '.mc-item__tags'].forEach(function (sel) {
                const s = src.querySelector(sel);
                const t = rowEl.querySelector(sel);
                if (s && t) t.innerHTML = s.innerHTML;
                else if (s && !t) {
                  const q = rowEl.querySelector('quantity-input');
                  if (q) q.insertAdjacentElement('afterend', s.cloneNode(true));
                } else if (!s && t) t.remove();
              });
            });
            // Reconcile the changed input to server truth (clamping, stock limits).
            const qi = document.getElementById('Drawer-quantity-' + line);
            const srv = parsed.items && parsed.items[line - 1];
            if (qi && srv) { qi.value = srv.quantity; qi.setAttribute('value', srv.quantity); }
          }
          const bubbleHTML = parsed.sections && parsed.sections['cart-icon-bubble'];
          if (bubbleHTML) {
            const bdoc = new DOMParser().parseFromString(bubbleHTML, 'text/html');
            const nb = bdoc.getElementById('cart-icon-bubble');
            const cb = document.getElementById('cart-icon-bubble');
            if (nb && cb) cb.innerHTML = nb.innerHTML;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsed, variantId: variantId });
          }
        })
        .catch(function () {
          const errBox = document.getElementById('CartDrawer-CartErrors');
          if (errBox) errBox.textContent = window.cartStrings ? window.cartStrings.error : 'Error';
        })
        .finally(function () {
          self.disableLoading(line);
          document.querySelectorAll('#CartDrawer .quantity__button.is-loading').forEach(function (b) {
            b.classList.remove('is-loading');
          });
        });
    };
  });
})();
